import * as autobind from 'autobind';
import React, { Component, Fragment } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { Dimmer, Loader } from 'semantic-ui-react';
import TailwindEventInstructorsSelector from 'widgets/bussiness/selectors/instructors-selector-tw';
import {
  DateTimePeriod,
  InstructorTabEventsStore,
  EventDto,
  EventInstructorDto,
  EventUserDto,
  TravelRangeDto,
  ChangeUnblockButtonsStore
} from 'stores/events/events-store';
import TailwindPeriodInput from 'widgets/form/period-input-tw';
import { ItemReference } from 'stores/dataStore';
import { IdentityService, Roles } from 'services/identity-service';
import { resolve } from 'inversify-react';
import TailwindChooseInstructorsWithGhostsView from 'widgets/form/choose-instructors-with-ghosts-form-tw';
import TailwindEventInstructorRoleEditor from 'widgets/bussiness/event-instructor-role-editor-tw';
import { InstructorExpertiseDto, InstructorTabExpertiseStore } from 'stores/skills/instructor-expertise-store';
//import './instructor-tab-pane.less';
import { connect } from 'redux-scaffolding-ts';
import { DateTimeService } from 'services/datetime-service';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { EventFormStore, EventFormViewModel, EventInstructorViewModel, PlannerAssistantOrigen } from 'stores/events/event-form-store';
import TailwindLocationEditor from 'widgets/bussiness/location-editor-tw';
import { getNextStatus, isOfCategory } from 'utils/event-utils';
import { isNullOrEmptyOrWhiteSpaces, isNullOrWhiteSpaces } from 'utils/useful-functions';
import { EventTypeCategory } from 'stores/configuration/events-workflow/event-types-store';
import { RoleInLocationDto, UserDto, UserStore } from 'stores/users/users-store';
import { isUserEventOwner } from 'utils/event-utils';
import { DatesRangeInput } from 'widgets/form/datesRangeInput';
import { getEventOwners } from 'utils/event-type-utils';
import { MachineListItemViewModel } from 'widgets/items-list/machine-list-item-deprecated';
import { InstructorDto, InstructorStore } from 'stores/instructors/instructors-store';
import TailwindAddExpertisePopup from 'site/pages/events/event-form/popups/add-expertise-popup/add-expertise-popup-tw';

interface EventInstructorContainerProps extends WithTranslation {
  selectedEventFormViewModel: EventFormViewModel;
  onClose: (isSuccess: boolean) => void;
  onKeepOpen?: (keepOpen: boolean) => void;
  isTabReadonly: boolean;
  showWorkingDays?: boolean;
  readOnly: boolean;
  events?: InstructorTabEventsStore;
  eventFormStore?: EventFormStore;
  instructorExpertiseStore?: InstructorTabExpertiseStore;
  changeUnblockButtonsStore?: ChangeUnblockButtonsStore;
  usersStore?: UserStore;
  selectedEvent?: EventDto;
  instructorStore?: InstructorStore;
}

interface EventInstructorContainerState {
  selectedEventFormViewModel: EventFormViewModel;
  intructorSelectorShown: boolean;
  notConflictOtherEventsDates?: boolean;
  recomendedInstructorsByExpertise: EventUserDto[];
  canAddInstructor: boolean;
  showAddExpertiseModal: boolean;
  instructorExpertise: UserDto;
  multipleInstructorsExpertise: string[];
  instructorExpertiseDefined: boolean;
  modalPlannerAssistant: boolean;
  loadingSelectedInstructorInfo: boolean;
  origen: PlannerAssistantOrigen;
}

interface EventPerInstructor {
  event: EventDto;
  instructor: EventInstructorDto;
}

@connect(
  ['instructorExpertiseStore', InstructorTabExpertiseStore],
  ['events', InstructorTabEventsStore],
  ['eventFormStore', EventFormStore],
  ['changeUnblockButtonsStore', ChangeUnblockButtonsStore],
  ['usersStore', UserStore],
  ['instructorStore', InstructorStore]
)
class EventInstructorContainer extends Component<EventInstructorContainerProps, EventInstructorContainerState> {
  @resolve(IdentityService)
  private identityService: IdentityService;

  private get changeUnblockButtonsStore() {
    return this.props.changeUnblockButtonsStore;
  }

  state: EventInstructorContainerState = {
    selectedEventFormViewModel: this.props.selectedEventFormViewModel,
    intructorSelectorShown: false,
    notConflictOtherEventsDates: false,
    recomendedInstructorsByExpertise: [],
    canAddInstructor: (this.props.selectedEventFormViewModel.instructors || []).length > 0 ? false : true,
    loadingSelectedInstructorInfo: false,
    modalPlannerAssistant: false,
    showAddExpertiseModal: false,
    instructorExpertise: null,
    multipleInstructorsExpertise: [],
    instructorExpertiseDefined: false,
    origen: 'instructorTabPane'
  };

  componentDidMount() {
    if (!this.props.isTabReadonly && !this.props.readOnly) {
      this.getRecomendedInstructors();
    }
    if (
      this.state.selectedEventFormViewModel &&
      this.state.selectedEventFormViewModel.instructors &&
      this.state.selectedEventFormViewModel.instructors.length > 0
    ) {
      this.validateInstructorFromInstructorViewModel(this.state.selectedEventFormViewModel.instructors, 0, true);
    }
  }

  private buildODataRecomendedInstructorsByExpertiseQueryFilter() {
    const { eventDetails, trainingDetails, eventType } = this.state.selectedEventFormViewModel;

    const filters: any[] = [{ EventTypeId: { eq: { type: 'guid', value: eventType.id } } }];

    if (eventDetails?.profession?.id)
      filters.push({ or: [{ RoleId: { eq: null } }, { RoleId: { eq: { type: 'guid', value: eventDetails.profession.id } } }] });

    if (trainingDetails?.trainingLevel?.id)
      filters.push({
        or: [{ TrainingLevelId: { eq: null } }, { TrainingLevelId: { eq: { type: 'guid', value: trainingDetails.trainingLevel.id } } }]
      });

    const hasFuncSubArea = eventDetails?.nmrFunctionalArea && eventDetails?.nmrFunctionalSubArea?.id;
    const hasMachineModel = (eventDetails?.machines || []).length !== 0;

    if (eventDetails?.machineRelated && hasMachineModel)
      filters.push({
        and: [
          {
            or: [
              { MachineModelId: { eq: null } },
              {
                MachineModelId:
                  (eventDetails.machines || []).filter(machine => !!machine.machineModel).length > 0
                    ? {
                        in: {
                          type: 'guid',
                          value: eventDetails.machines.filter(machine => !!machine.machineModel).map(x => x.machineModel.id)
                        }
                      }
                    : { eq: null }
              }
            ]
          },
          { NMRFunctionalSubAreaId: { eq: null } }
        ]
      });

    if (eventDetails && !eventDetails.machineRelated && hasFuncSubArea) {
      filters.push({
        and: [
          {
            or: [
              { NMRFunctionalSubAreaId: { eq: null } },
              { NMRFunctionalSubAreaId: { eq: { type: 'guid', value: eventDetails?.nmrFunctionalSubArea?.id || null } } }
            ]
          },
          { MachineModelId: { eq: null } }
        ]
      });
    }

    return filters;
  }

  private buildODataRecomendedInstructorsQueryFilter() {
    const filters: any[] = [];
    if (this.isPoc()) {
      filters.push({ instructorRole: { name: { eq: 'Internal Trainer' } } });
    }
    return filters;
  }

  private getRecomendedInstructors() {
    this.setState({ canAddInstructor: false });

    const query = {
      searchQuery: '',
      skip: 0,
      take: 100000,
      orderBy: [],
      filter: this.buildODataRecomendedInstructorsQueryFilter()
    };

    this.props.instructorStore.getAllAsync(query).then(instructor => {
      let recomendedInstructors: EventUserDto[] = instructor.items.map(x => ({
        firstName: x.name,
        id: x.userId,
        lastName: x.surname,
        location: x.location,
        pillar: x.pillar
      }));

      this.setState({
        recomendedInstructorsByExpertise: recomendedInstructors,
        canAddInstructor: true
      });
    });
  }

  private getRecomendedInstructorsByExpertise() {
    this.setState({ canAddInstructor: false });
    const query = {
      searchQuery: '',
      skip: 0,
      take: 100000,
      orderBy: [],
      filter: this.buildODataRecomendedInstructorsByExpertiseQueryFilter(),
      select: 'id, InstructorId'
    };
    this.props.instructorExpertiseStore.getAllAsync(query, true).then(instructorExpertises => {
      const recomendedInstructorsByExpertise: EventUserDto[] = instructorExpertises.items
        .filter(x => (x?.user?.roles || []).any(y => y?.role?.name === 'Instructor'))
        .map(({ user: { firstName, id, lastName, roles, pillar } }) => {
          const location = roles.find(y => y.role.name === 'Instructor')?.location;
          return { firstName, id, lastName, location, pillar };
        });

      this.setState({ recomendedInstructorsByExpertise, canAddInstructor: true });
    });
  }

  private mapToEventInstructor(events: EventDto[]) {
    const eventsPerInstructor: EventPerInstructor[] = [];
    events.forEach(event => eventsPerInstructor.push(...event.instructors.map(instructor => ({ event, instructor }))));
    return eventsPerInstructor;
  }

  arraysAreEquals = (array_1, array_2) => array_1.length === array_2.length && array_1.every((v, i) => v === array_2[i]);

  private async getInstructorEventsByIds(ids: string[]) {
    this.setState({ canAddInstructor: false });
    let idsFilter = ids.map(id => {
      return { InstructorId: { eq: { type: 'guid', value: id } } };
    });
    const filter = [
      {
        eventInstructors: {
          any: {
            or: idsFilter
          }
        }
      }
    ];
    const queryEvents = {
      searchQuery: '',
      filter,
      orderBy: [],
      skip: 0,
      take: 100000,
      select: 'id,FriendlyEventId,startDate, endDate'
    };
    this.setState({ canAddInstructor: true });
    return this.props.events.getAllAsync(queryEvents);
  }

  private checkWarningMessages(instructors: EventInstructorViewModel[]): string[] {
    let notInDate: boolean = false;
    let notValid: boolean = false;
    let notConflict: boolean = false;
    const messages: string[] = [];

    for (const instructor of instructors) {
      if (!!instructor.notInDate) notInDate = true;
      if (!!instructor.notValid) notValid = true;
      if (!!instructor.notConflict) notConflict = true;
    }

    if (notInDate) messages.push('There is a conflict with the Dates');

    if (notValid) messages.push("There is a conflict with the Intructor's Expertise");

    if (notConflict) messages.push("There is a conflict with others Instructor's Events");

    return messages;
  }

  async getEventInstructorAvailability(
    newInstructors: InstructorExpertiseDto[],
    index: number,
    multiple: boolean = false
  ): Promise<EventInstructorViewModel[]> {
    const { startDate, endDate } = this.state.selectedEventFormViewModel;
    const instructorIds = multiple ? newInstructors.map(x => x.instructorId) : [newInstructors[index].instructorId];
    const eventsInstructors = await this.getInstructorEventsByIds(instructorIds).then(events => this.mapToEventInstructor(events.items));
    const instructorId = newInstructors[index].instructorId;
    const finalEvents = eventsInstructors.filter(x => x.instructor.instructorId === instructorId);

    const newInstructorRows = newInstructors.map(({ user, instructorId }: InstructorExpertiseDto) => {
      const newInstructorRow: EventInstructorViewModel = {
        location: {
          id: user.roles.find(({ role }) => role.name === 'Instructor')?.location?.id || '0',
          title: user.roles.find(({ role }) => role.name === 'Instructor')?.location?.location || ''
        },
        period: { from: startDate, to: endDate },
        role: undefined,
        user,
        workingDays: null,
        workingHours: null,
        travelDays: null,
        notValid: false,
        notInDate: false,
        notConflict: false,
        noTravel: false
      };

      newInstructorRow.notValid = !this.isRecommendedInstructorToValided(newInstructorRow);
      newInstructorRow.notConflict = this.hasConflictsWithOtherEventInstructors(finalEvents);
      this.handleIfInstructorUserHasValidated(instructorId);
      return newInstructorRow;
    });
    return newInstructorRows;
  }

  async getEventInstructorDtoAvailability(
    newInstructors: InstructorDto[],
    index: number,
    multiple: boolean = false
  ): Promise<EventInstructorViewModel[]> {
    const { startDate, endDate } = this.state.selectedEventFormViewModel;
    const instructorIds = multiple ? newInstructors.map(x => x.userId) : [newInstructors[index].userId];
    const eventsInstructors = await this.getInstructorEventsByIds(instructorIds).then(events => this.mapToEventInstructor(events.items));
    const instructorId = newInstructors[index].userId;
    const finalEvents = eventsInstructors.filter(x => x.instructor.instructorId === instructorId);

    const newInstructorRows = newInstructors.map((instructorDto: InstructorDto) => {
      const newInstructorRow: EventInstructorViewModel = {
        location: {
          id: instructorDto?.location?.id || '0',
          title: instructorDto?.location?.location || ''
        },
        period: { from: startDate, to: endDate },
        role: undefined,
        user: instructorDto.user,
        workingDays: null,
        workingHours: null,
        travelDays: null,
        notValid: false,
        notInDate: false,
        notConflict: false,
        noTravel: false
      };

      newInstructorRow.notValid = !this.isRecommendedInstructorToValided(newInstructorRow);
      newInstructorRow.notConflict = this.hasConflictsWithOtherEventInstructors(finalEvents);
      this.handleIfInstructorUserHasValidated(instructorId);
      return newInstructorRow;
    });
    return newInstructorRows;
  }

  private isPlannerTFT = () => {
    const userinfo = this.identityService.getUserInfo();
    return IdentityService.isPlannerTFT(userinfo);
  };

  private isPlannerMTC = () => {
    const userinfo = this.identityService.getUserInfo();
    return IdentityService.isPlannerMTC(userinfo);
  };

  private isAdmin = () => {
    const userinfo = this.identityService.getUserInfo();
    return IdentityService.isAdmin(userinfo);
  };

  private isPoc = () => {
    const userinfo = this.identityService.getUserInfo();
    return IdentityService.isPoc(userinfo);
  };

  private isEventOwner = (eventOwners: string[]) => {
    const userinfo = this.identityService.getUserInfo();
    return eventOwners.any(x => IdentityService.roles[Roles[x]] === userinfo.activeRole);
  };

  private async onSelectedInstructor(newInstructors: InstructorExpertiseDto[]) {
    this.setState({ loadingSelectedInstructorInfo: true });
    const newInstructorRows = await this.getEventInstructorAvailability(newInstructors, 0);
    const warningMessages = this.checkWarningMessages(newInstructorRows);

    this.setState({ showAddExpertiseModal: true, multipleInstructorsExpertise: [], instructorExpertise: null });
    const newInstructorsExpertise = [];
    newInstructorRows.forEach(instructor => {
      newInstructorsExpertise.push(instructor.user.id);
    });
    this.setState({ showAddExpertiseModal: true, multipleInstructorsExpertise: newInstructorsExpertise });

    const sefvm = { ...this.state.selectedEventFormViewModel };
    const instructors = [...sefvm.instructors, ...newInstructorRows];
    this.props.eventFormStore.change({ instructors, warningMessages });

    sefvm.instructors = instructors;
    this.setState({ selectedEventFormViewModel: sefvm });
    this.setState({ loadingSelectedInstructorInfo: false });
  }

  private hasConflictsWithOtherEventInstructors(eventsPerInstructor: EventPerInstructor[]): boolean {
    if (!this.props.eventFormStore?.state?.item) return false;

    const { startDate, endDate } = this.props.eventFormStore?.state?.item;

    return eventsPerInstructor.some(({ event }) =>
      DateTimeService.dateRangeOverlaps(
        DateTimeService.toDateRange(event.startDate, event.endDate),
        DateTimeService.toDateRange(startDate, endDate)
      )
    );
  }

  private isRecommendedInstructorToValided(instructor: EventInstructorViewModel): boolean {
    if (!instructor.user) return false;
    else return !!this.state.recomendedInstructorsByExpertise.find(x => x.id === instructor.user.id);
  }

  private isRecommendedInstructor(instructor: EventInstructorViewModel): boolean {
    if (!instructor.user) return false;
    return !!this.state.recomendedInstructorsByExpertise.find(x => x.id === instructor.user.id);
  }

  private handleOnLocationChange = (index: number, newLocation: ItemReference) => {
    const instructors = [...this.state.selectedEventFormViewModel.instructors];
    instructors[index].location = newLocation;
    if (!newLocation) instructors[index].user = null;

    this.props.eventFormStore.change({ instructors });
  };

  private mapEventInstructorToInstructorExpertise(instructors: EventInstructorViewModel[]): InstructorDto[] {
    const instructorUsers = instructors.filter(x => !!x.user);
    const instructorExpertises = instructorUsers.map(x => {
      const instructorRole = {
        role: {
          name: 'Instructor'
        },
        location: x.user.location
      } as RoleInLocationDto;

      const model = { userId: x.user.id, user: { id: x.user.id, roles: [instructorRole] } };
      return model as InstructorDto;
    });
    return instructorExpertises;
  }

  private validateInstructorFromInstructorViewModel(instructors: EventInstructorViewModel[], index: number, multiple: boolean = false) {
    const instructorExpertises = this.mapEventInstructorToInstructorExpertise(instructors);
    this.getEventInstructorDtoAvailability(instructorExpertises, index, multiple).then(eventInstructors => {
      if (eventInstructors && eventInstructors.length > 0) {
        if (multiple) {
          instructors.forEach((x, index) => {
            if (instructors[index]) {
              instructors[index].notConflict = eventInstructors[index]?.notConflict;
              instructors[index].notValid = eventInstructors[index]?.notValid;
            }
          });
        } else {
          instructors[index].notConflict = eventInstructors[index]?.notConflict;
          instructors[index].notValid = eventInstructors[index]?.notValid;
        }
      }
      const warningMessages = this.checkWarningMessages(instructors);
      this.props.eventFormStore.change({ instructors, warningMessages });
    });
  }

  private buildIsAlredyInstructorExpertiseDefinedFilter(
    instructor: UserDto,
    eventTypeId: string,
    roleId: string,
    trainingLevelId: string,
    machines: MachineListItemViewModel[]
  ) {
    const filters: any[] = [{ IsMachineRelated: { eq: true } }];
    filters.push({ InstructorId: { eq: { type: 'guid', value: instructor.id } } });
    filters.push({ EventTypeId: { eq: { type: 'guid', value: eventTypeId } } });
    filters.push({ RoleId: { eq: { type: 'guid', value: roleId } } });
    filters.push({ TrainingLevelId: { eq: { type: 'guid', value: trainingLevelId } } });

    const machine = machines.firstOrDefault();
    if (machine) {
      if (machine.cluster) filters.push({ MachineRelatedClusterId: { eq: { type: 'guid', value: machine.cluster.id } } });
      if (machine.equipmentType) filters.push({ EquipmentTypeId: { eq: { type: 'guid', value: machine.equipmentType.id } } });
      if (machine.oem) filters.push({ OemId: { eq: { type: 'guid', value: machine.oem.id } } });
      if (machine.machineModel) filters.push({ MachineModelId: { eq: { type: 'guid', value: machine.machineModel.id } } });
    }

    return filters;
  }

  private async IsAlredyInstructorExpertiseDefined(instructor: UserDto) {
    const { selectedEventFormViewModel } = this.state;
    const isMachineRelated = selectedEventFormViewModel.eventDetails ? selectedEventFormViewModel.eventDetails.machineRelated : false;
    const machines = selectedEventFormViewModel.eventDetails ? selectedEventFormViewModel.eventDetails.machines : [];
    const eventTypeId = selectedEventFormViewModel.eventType.id;
    const roleId = selectedEventFormViewModel.eventDetails ? selectedEventFormViewModel.eventDetails.profession.id : null;
    const trainingLevelId = selectedEventFormViewModel.trainingDetails.trainingLevel
      ? selectedEventFormViewModel.trainingDetails.trainingLevel.id
      : null;

    if (!isMachineRelated) return true;
    if ((machines || []).length !== 1) return false;

    let isAlredyInstructorExpertiseDefined: boolean = false;

    const query = {
      searchQuery: '',
      skip: 0,
      take: 100000,
      orderBy: [],
      filter: this.buildIsAlredyInstructorExpertiseDefinedFilter(instructor, eventTypeId, roleId, trainingLevelId, machines),
      select: 'id, InstructorId'
    };

    isAlredyInstructorExpertiseDefined = await this.props.instructorExpertiseStore.getAllAsync(query, true).then(instructorExpertises => {
      const instructorsByExpertise = instructorExpertises.items;
      return instructorsByExpertise.length > 0;
    });

    return isAlredyInstructorExpertiseDefined;
  }

  private getInstructor = async (id?: string): Promise<boolean> => {
    try {
      this.setState({
        instructorExpertiseDefined: false,
        canAddInstructor: false,
        multipleInstructorsExpertise: [],
        instructorExpertise: null
      });
      if (id) {
        const instructorData = await this.props.usersStore.getUserById(id);
        const instructorExpertiseDefined = await this.IsAlredyInstructorExpertiseDefined(instructorData);
        this.setState({
          instructorExpertise: instructorData,
          instructorExpertiseDefined: instructorExpertiseDefined,
          canAddInstructor: true
        });
      } else {
        this.setState({ instructorExpertise: null, instructorExpertiseDefined: false, canAddInstructor: true });
      }
    } catch {
      this.setState({ instructorExpertise: null, instructorExpertiseDefined: false, canAddInstructor: true });
      return false;
    }
    return true;
  };

  private handleOnInstructorChange(index: number, propertyName: keyof EventInstructorViewModel, newValue: any) {
    const instructors = [...this.state.selectedEventFormViewModel.instructors];
    instructors[index][propertyName as string] = newValue;

    this.props.eventFormStore.change({ instructors: instructors });
  }

  private handleOnPeriodChange = (index: number, period: DateTimePeriod) => {
    const { startDate, endDate, instructors: currInstructors } = this.state.selectedEventFormViewModel;
    const isFromAfterTo = DateTimeService.toMoment(period.from).isAfter(period.to, 'D');
    const isFromBeforeStart = DateTimeService.toMoment(period.from).isBefore(startDate, 'D');
    const isFromAfterEnd = DateTimeService.toMoment(period.from).isAfter(endDate, 'D');
    const isToBeforeStart = DateTimeService.toMoment(period.to).isBefore(startDate, 'D');
    const isToAfterEnd = DateTimeService.toMoment(period.to).isAfter(endDate, 'D');
    const notInDate = isFromBeforeStart || isFromAfterEnd || isToBeforeStart || isToAfterEnd || isFromAfterTo;
    const instructors = (currInstructors || []).map((instructor, i) => {
      if (i === index) {
        const currInstructor = { ...instructor };
        if (notInDate) currInstructor.notInDate = notInDate;
        if (isFromBeforeStart || isFromAfterEnd) currInstructor.period = { ...currInstructor.period, from: startDate };
        else if (isToBeforeStart || isToAfterEnd) currInstructor.period = { ...currInstructor.period, to: endDate };
        else if (isFromAfterTo) currInstructor.period = { from: period.from, to: period.from };
        else currInstructor.period = period;
        return currInstructor;
      }
      return instructor;
    });

    this.props.eventFormStore.change({ instructors, fromScheduler: false });
  };

  private canEditWorkingTime({ user }: EventInstructorViewModel) {
    const userInfo = this.identityService.getUserInfo();
    const isAdminOrPoc = IdentityService.isAdminOrPoc(userInfo);
    const { readOnly } = this.props;
    const { selectedEventFormViewModel } = this.state;
    const eventNextStatus = (getNextStatus(selectedEventFormViewModel) || '').toString();
    const isEO = isUserEventOwner(selectedEventFormViewModel);
    return !readOnly && eventNextStatus === 'Closed' && (user?.id === this.identityService.userId || isEO || isAdminOrPoc);
  }

  private canEditWorkingDaysAndTravelDates({ user, noTravel }: EventInstructorViewModel) {
    const userInfo = this.identityService.getUserInfo();
    const isAdminOrPoc = IdentityService.isAdminOrPoc(userInfo);
    const { isTabReadonly, readOnly } = this.props;
    const { selectedEventFormViewModel } = this.state;
    const isEO = isUserEventOwner(selectedEventFormViewModel);
    const canEditWorkingDays = (!isTabReadonly || !readOnly) && (user?.id === this.identityService.userId || isEO || isAdminOrPoc);

    return canEditWorkingDays && !noTravel;
  }

  private canEditWorkingDaysAndNoTravel({ user, travelDays }: EventInstructorViewModel) {
    const userInfo = this.identityService.getUserInfo();
    const isAdminOrPoc = IdentityService.isAdminOrPoc(userInfo);
    const { isTabReadonly, readOnly } = this.props;
    const { selectedEventFormViewModel } = this.state;
    const isEO = isUserEventOwner(selectedEventFormViewModel);

    const canEditWorkingDays = (!isTabReadonly || !readOnly) && (user?.id === this.identityService.userId || isEO || isAdminOrPoc);
    return (
      canEditWorkingDays &&
      !travelDays?.departure?.from &&
      !travelDays?.departure?.to &&
      !travelDays?.arrival?.from &&
      !travelDays?.arrival?.to
    );
  }

  private addInstructorRow = () => {
    const sefvm = { ...this.state.selectedEventFormViewModel };
    const { startDate, endDate } = sefvm;
    const emptyInstructorRow: EventInstructorViewModel = {
      location: undefined,
      period: { from: startDate, to: endDate },
      role: undefined,
      user: undefined,
      workingDays: undefined,
      workingHours: undefined,
      travelDays: undefined,
      noTravel: false
    };

    const instructors = [...sefvm.instructors, emptyInstructorRow];
    sefvm.instructors = instructors;
    this.setState({ selectedEventFormViewModel: sefvm });
    this.props.eventFormStore.change({ instructors });
  };

  private handleOnRemoveInstructor = (index: number) => {
    const instructors = this.state.selectedEventFormViewModel.instructors.filter((_, i) => index !== i);
    const warningMessages = this.checkWarningMessages(instructors);
    this.props.eventFormStore.change({ instructors, warningMessages });
    this.props.onKeepOpen && this.props.onKeepOpen(true);
  };

  private handleIfInstructorUserHasValidated = (instructorId: string) => {
    const { selectedEventFormViewModel } = this.state;
    const statusValidation = { ...selectedEventFormViewModel.statusValidation };
    let {
      validatedByPlanners,
      validatedByInstructors,
      validatedByEmployees,
      validatedByPoC,
      validatedByFactoryLead,
      validatedByPlannersMTC
    } = statusValidation;

    if (!isNullOrWhiteSpaces(instructorId) && (validatedByEmployees || validatedByPlanners || validatedByPoC || validatedByPlannersMTC)) {
      if ((validatedByEmployees || []).length > 0 && validatedByEmployees.includes(instructorId))
        validatedByEmployees = validatedByEmployees.filter(userId => userId !== instructorId);

      if ((validatedByPlanners || []).length > 0 && validatedByPlanners.includes(instructorId))
        validatedByPlanners = validatedByPlanners.filter(userId => userId !== instructorId);

      if ((validatedByPlannersMTC || []).length > 0 && validatedByPlannersMTC.includes(instructorId))
        validatedByPlannersMTC = validatedByPlannersMTC.filter(userId => userId !== instructorId);

      if ((validatedByPoC || []).length > 0 && validatedByPoC.includes(instructorId))
        validatedByPoC = validatedByPoC.filter(userId => userId !== instructorId);

      if ((validatedByInstructors || []).length > 0 && validatedByInstructors.includes(instructorId))
        validatedByInstructors = validatedByInstructors.filter(userId => userId !== instructorId);

      if ((validatedByFactoryLead || []).length > 0 && validatedByFactoryLead.includes(instructorId))
        validatedByFactoryLead = validatedByFactoryLead.filter(userId => userId !== instructorId);
    }

    this.props.eventFormStore.change({ statusValidation });
  };

  private handleUnblockedForeignResourcesForPlannerTFTChanged(checked: boolean): void {
    const event = { ...this.state.selectedEventFormViewModel };
    event.unblockedForeignResourcesForPlannerTFT = checked;

    this.changeUnblockButtonsStore.updateUnlockButtons({
      id: this.state.selectedEventFormViewModel?.id,
      unblockedForeignResourcesForPlannerTFT: event.unblockedForeignResourcesForPlannerTFT,
      unblockedForeignResourcesForPlannerMTC: event.unblockedForeignResourcesForPlannerMTC
    });

    this.props.eventFormStore.change({ unblockedForeignResourcesForPlannerTFT: checked });
  }

  private handleUnblockedForeignResourcesForPlannerMTCChanged(checked: boolean): void {
    const event = { ...this.state.selectedEventFormViewModel };
    event.unblockedForeignResourcesForPlannerMTC = checked;

    this.changeUnblockButtonsStore.updateUnlockButtons({
      id: this.state.selectedEventFormViewModel?.id,
      unblockedForeignResourcesForPlannerTFT: event.unblockedForeignResourcesForPlannerTFT,
      unblockedForeignResourcesForPlannerMTC: event.unblockedForeignResourcesForPlannerMTC
    });

    this.props.eventFormStore.change({ unblockedForeignResourcesForPlannerMTC: checked });
  }

  componentDidUpdate(prevProps) {
    const { eventFormStore, isTabReadonly, readOnly } = this.props;
    const { state } = eventFormStore;
    if (!isTabReadonly && !readOnly && prevProps.isTabReadonly !== isTabReadonly && prevProps.readOnly !== readOnly) {
      this.getRecomendedInstructors();
    }
    if (!state.item) return;
    if (state.item.fromScheduler) return;

    const { startDate, endDate, hasSupportDetails } = state.item;

    if (hasSupportDetails) {
      const start = DateTimeService.toMoment(startDate);
      const end = DateTimeService.toMoment(endDate);
      const notInEventDate = (state.item.instructors || []).any(({ period: { from, to } }, i) => {
        const fromDate = DateTimeService.toMoment(from);
        const toDate = DateTimeService.toMoment(to);
        return start.isAfter(fromDate, 'D') || end.isBefore(toDate, 'D');
      });
      if (notInEventDate) {
        const instructors = (state.item.instructors || []).map(instructor => {
          const period = { ...instructor.period };
          const fromDate = DateTimeService.toMoment(period.from);
          const toDate = DateTimeService.toMoment(period.to);

          if (start.isAfter(fromDate, 'D') || start.isAfter(toDate, 'D') || end.isBefore(toDate, 'D')) {
            if (start.isAfter(fromDate, 'D')) period.from = startDate;
            if (start.isAfter(toDate, 'D')) period.to = startDate;
            if (end.isBefore(toDate, 'D')) period.to = endDate;
            return { ...instructor, period };
          }
          return instructor;
        });
        eventFormStore.change({ instructors });
      }
    }
  }

  handleTravelDays = (index: number, property: keyof TravelRangeDto, value: DateTimePeriod) => {
    const { instructors } = this.state.selectedEventFormViewModel;
    const instructor = instructors[index];
    this.handleOnInstructorChange(index, 'travelDays', { ...instructor.travelDays, [property]: value });
  };

  handleNoTravel = (index: number, value: boolean) => {
    this.handleOnInstructorChange(index, 'noTravel', value);
  };

  private handleOnAddInstructorExpertise = () => {
    this.hideAddInstructorExpertiseModal();
  };

  private hideAddInstructorExpertiseModal = () => {
    this.setState({ showAddExpertiseModal: false, multipleInstructorsExpertise: [], instructorExpertise: null });
  };

  private isPlanner = () => {
    const userinfo = this.identityService.getUserInfo();
    return IdentityService.isPlanner(userinfo);
  };

  @autobind
  private onPlannerAssistantClosed() {
    this.setState({ modalPlannerAssistant: false });
  }

  private handleOnInstructorUserChange = async (index: number, user: EventUserDto) => {
    const instructors = [...this.state.selectedEventFormViewModel.instructors];
    instructors[index].user = user;

    this.setState({ showAddExpertiseModal: true });
    await this.getInstructor(instructors[index].user?.id);

    if (user?.location) instructors[index].location = { id: user.location.id, title: user.location.location };

    //DO NOT REMOVE. USE IF NECESSARY
    //this.handleIfInstructorUserHasValidated(user?.id);//> this call is unnecessary while validations are completely disabled since sprint 1 2024 update
    //this.validateInstructorFromInstructorViewModel(instructors, index);//> this call is removed because generate delays. NoConflict and NoValid are post calculated again.
    //DO NOT REMOVE. USE IF NECESSARY

    this.props.eventFormStore.change({ instructors });
  };

  private handlePlannerAssistantOnClick = () => {
    this.setState({ modalPlannerAssistant: true });
  };

  activeRoleCanSelectRowsForPlannerAssistant(): boolean {
    let currentUserInfo = this.identityService.getUserInfo();
    return IdentityService.isAdminOrPlanner(currentUserInfo);
  }

  public render() {
    const { t, isTabReadonly, instructorExpertiseStore, eventFormStore } = this.props;
    const { selectedEventFormViewModel } = this.state;
    const {
      unblockedForeignResourcesForPlannerTFT,
      unblockedForeignResourcesForPlannerMTC,
      instructors,
      status
    } = selectedEventFormViewModel;
    const {
      recomendedInstructorsByExpertise,
      intructorSelectorShown,
      canAddInstructor,
      loadingSelectedInstructorInfo,
      multipleInstructorsExpertise,
      instructorExpertise,
      showAddExpertiseModal,
      instructorExpertiseDefined
      //,origen
    } = this.state;
    const eventOwners = getEventOwners(selectedEventFormViewModel.eventType);

    const isMachineRelated = selectedEventFormViewModel.eventDetails ? selectedEventFormViewModel.eventDetails.machineRelated : false;
    const machines = selectedEventFormViewModel.eventDetails ? selectedEventFormViewModel.eventDetails.machines : [];
    const eventTypeId = selectedEventFormViewModel.eventType.id;
    const originalEventTypeId = selectedEventFormViewModel.eventType.originalEventTypeId;
    const roleId = selectedEventFormViewModel.eventDetails ? selectedEventFormViewModel.eventDetails.profession.id : null;
    const trainingLevelId =
      selectedEventFormViewModel.trainingDetails && selectedEventFormViewModel.trainingDetails.trainingLevel
        ? selectedEventFormViewModel.trainingDetails.trainingLevel.id
        : null;

    return (
      <>
        {(eventFormStore.state.isBusy || !canAddInstructor || loadingSelectedInstructorInfo) && (
          <div>
            <Dimmer active inverted>
              <Loader size="large" active inverted />
            </Dimmer>
          </div>
        )}

        <div className="p-4">
          <h3 className="text-lg font-semibold mb-4">{t('Instructors')}</h3>
          <button
            onClick={() => this.addInstructorRow()}
            disabled={isTabReadonly || !canAddInstructor}
            className="w-full bg-white-600 text-blue py-2 rounded mt-2 border border-gray-200"
          >
            {t('Add instructor')}
          </button>

          <button
            onClick={() => this.setState({ intructorSelectorShown: true })}
            disabled={isTabReadonly || !canAddInstructor}
            className={`w-full ${isTabReadonly || !canAddInstructor ? 'bg-gray-600' : 'bg-primary-600'} text-white py-2 rounded mt-2`}
          >
            {t('Show All Instructors')}
          </button>

          {intructorSelectorShown && (
            <TailwindChooseInstructorsWithGhostsView
              onSelectInstructors={items => this.onSelectedInstructor(items)}
              onCloseModal={() => this.setState({ intructorSelectorShown: false })}
              onlyInstructorsPlannerTFT={this.isPlannerTFT() && !unblockedForeignResourcesForPlannerTFT}
              onlyInstructorsPlannerMTC={this.isPlannerMTC() && !unblockedForeignResourcesForPlannerMTC}
            />
          )}

          {/* {!this.isPoc() && status.toString() === EventStatus[EventStatus.Draft] && (
            <button
              onClick={this.handlePlannerAssistantOnClick}
              disabled={isTabReadonly || !canAddInstructor}
              className="w-full bg-primary-600 text-white py-2 rounded mt-2"
            >
              {t('Planner Assistant')}
            </button>
          )} */}

          {/* {this.state.modalPlannerAssistant && (
            <PlannerAssistant onClose={this.onPlannerAssistantClosed} selectedEventRows={[this.props.selectedEvent]} origen={origen} />
          )} */}

          {(this.isEventOwner(eventOwners) || this.isAdmin() || this.isPlannerTFT() || this.isPlannerMTC()) &&
            eventOwners.any(x => x === 'PlannerMTC' || x === 'Planner') && (
              <>
                <div className="h-px w-full bg-gray-200 my-4" />
                <h3 className="text-lg font-semibold mb-4">{t('Unblock resources')}</h3>
                {(this.isEventOwner(eventOwners) || this.isAdmin() || this.isPlannerMTC()) && eventOwners.any(x => x === 'Planner') && (
                  <div className="flex gap-3 mb-3">
                    <div className="relative inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        checked={unblockedForeignResourcesForPlannerTFT}
                        onChange={e => this.handleUnblockedForeignResourcesForPlannerTFTChanged(e.target.checked)}
                        disabled={!this.isAdmin() && !(this.isPlannerMTC() && eventOwners.any(x => x === 'Planner'))}
                        className="sr-only peer"
                      />
                      <div
                        className="w-11 h-6 bg-gray-200 rounded-full peer 
    peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 
    dark:peer-focus:ring-blue-800 dark:bg-gray-700 
    peer-checked:after:translate-x-full peer-checked:after:border-white 
    after:content-[''] after:absolute after:top-[2px] after:left-[2px] 
    after:bg-white after:border-gray-300 after:border after:rounded-full 
    after:h-5 after:w-5 after:transition-all dark:border-gray-600 
    peer-checked:bg-primary-600"
                      ></div>
                      <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">{t('MTC')}</span>
                    </div>
                  </div>
                )}
                {(this.isEventOwner(eventOwners) || this.isAdmin() || this.isPlannerTFT()) && eventOwners.any(x => x === 'PlannerMTC') && (
                  <div className="lex gap-3 mb-3">
                    <div className="relative inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        checked={unblockedForeignResourcesForPlannerMTC ? unblockedForeignResourcesForPlannerMTC : false}
                        onChange={e => this.handleUnblockedForeignResourcesForPlannerMTCChanged(e.target.checked)}
                        disabled={!this.isAdmin() && !(this.isPlannerTFT() && eventOwners.any(x => x === 'PlannerMTC'))}
                        className="sr-only peer"
                      />
                      <div
                        className="w-11 h-6 bg-gray-200 rounded-full peer 
    peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 
    dark:peer-focus:ring-blue-800 dark:bg-gray-700 
    peer-checked:after:translate-x-full peer-checked:after:border-white 
    after:content-[''] after:absolute after:top-[2px] after:left-[2px] 
    after:bg-white after:border-gray-300 after:border after:rounded-full 
    after:h-5 after:w-5 after:transition-all dark:border-gray-600 
    peer-checked:bg-primary-600"
                      ></div>
                      <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">{t('TFT')}</span>
                    </div>
                  </div>
                )}
              </>
            )}
        </div>

        {(this.isAdmin() || this.isPlanner()) &&
          isMachineRelated &&
          showAddExpertiseModal &&
          ((instructorExpertise && !instructorExpertise.isPowerInstructor && !instructorExpertiseDefined) ||
            (multipleInstructorsExpertise || []).length > 0) && (
            <>
              <div className="h-px w-full bg-gray-200 my-4" />
              <div className="p-4">
                <TailwindAddExpertisePopup
                  machines={machines || []}
                  onSuccess={this.handleOnAddInstructorExpertise}
                  onCancel={this.hideAddInstructorExpertiseModal}
                  instructorIds={instructorExpertise || multipleInstructorsExpertise}
                  eventTypeId={eventTypeId}
                  originalEventTypeId={originalEventTypeId}
                  roleId={roleId}
                  trainingLevelId={trainingLevelId}
                />
              </div>
            </>
          )}

        <div className="p-4">
          {!instructorExpertiseStore.state.isBusy &&
            (instructors || []).map((instructor, index) => (
              <div key={index} className="bg-gray-50 rounded shadow p-4 mb-4 flex flex-col gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">{t("Instructor's Location")}</label>
                  <TailwindLocationEditor
                    readOnly={!instructor.user || this.isRecommendedInstructor(instructor) ? isTabReadonly : true}
                    className="w-full border border-gray-300 rounded px-2 py-1"
                    value={instructor.location}
                    nullable
                    clearable
                    onChange={location => this.handleOnLocationChange(index, location)}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">{t("Instructor's Name")}</label>
                  {!instructor.user || this.isRecommendedInstructor(instructor) ? (
                    <TailwindEventInstructorsSelector
                      readOnly={isTabReadonly}
                      className="w-full border border-gray-300 rounded px-2 py-1"
                      value={instructor.user?.id || null}
                      locationId={instructor.location?.id || null}
                      clearable
                      onChange={user => this.handleOnInstructorUserChange(index, user)}
                      options={recomendedInstructorsByExpertise}
                      onlyInstructorsPlannerTFT={this.isPlannerTFT() && !unblockedForeignResourcesForPlannerTFT}
                      onlyInstructorsPlannerMTC={this.isPlannerMTC() && !unblockedForeignResourcesForPlannerMTC}
                    />
                  ) : (
                    <TailwindEventInstructorsSelector
                      readOnly
                      className="w-full border border-gray-300 rounded px-2 py-1"
                      value={instructor.user?.id || null}
                      options={[instructor?.user]}
                      onlyInstructorsPlannerTFT={this.isPlannerTFT() && !unblockedForeignResourcesForPlannerTFT}
                      onlyInstructorsPlannerMTC={this.isPlannerMTC() && !unblockedForeignResourcesForPlannerMTC}
                    />
                  )}
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">{t('Role')}</label>
                  <TailwindEventInstructorRoleEditor
                    readOnly={isTabReadonly}
                    key={`roleeditor-${instructor.role ? instructor.role.toString() : 'undefined'}-${index}`}
                    className="w-full border border-gray-300 rounded px-2 py-1"
                    value={instructor.role}
                    onChange={role => this.handleOnInstructorChange(index, 'role', role)}
                  />
                </div>
                {!isTabReadonly && instructor.user && !isNullOrEmptyOrWhiteSpaces(instructor.supportPositionId) && (
                  <div>
                    <label className={'block text-sm font-medium text-red-700 mb-1'}>
                      <FontAwesomeIcon icon={faExclamationTriangle} className="w-5 h-5 text-yellow-500" />
                      <div>
                        <p key={'warning-' + index}>
                          {' '}
                          {instructor.user.firstName +
                            ' ' +
                            instructor.user.lastName +
                            t(' is linked with his own position in the support details. Please, make the changes there.')}{' '}
                        </p>
                      </div>
                    </label>
                  </div>
                )}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">{t('Period Dates')}</label>
                  <TailwindPeriodInput
                    id={'instructors-tab-pane-' + index}
                    readOnly={isTabReadonly || !isNullOrEmptyOrWhiteSpaces(instructor.supportPositionId)}
                    value={instructor.period}
                    onChange={value => this.handleOnPeriodChange(index, value)}
                    min={instructor.period?.from}
                  />
                </div>
                {!isOfCategory(selectedEventFormViewModel, EventTypeCategory.Vacations) && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">{t('Working Days')}</label>
                    <input
                      readOnly={!this.canEditWorkingTime(instructor) || !isNullOrEmptyOrWhiteSpaces(instructor.supportPositionId)}
                      disabled={!this.canEditWorkingTime(instructor) || !isNullOrEmptyOrWhiteSpaces(instructor.supportPositionId)}
                      className="w-full border border-gray-300 rounded px-2 py-1"
                      value={instructor.workingDays ?? ''}
                      onChange={e => this.handleOnInstructorChange(index, 'workingDays', e.target.value)}
                    />
                  </div>
                )}
                {!isOfCategory(selectedEventFormViewModel, EventTypeCategory.Vacations) && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">{t('Working Hours')}</label>
                    <input
                      readOnly={!this.canEditWorkingTime(instructor) || !isNullOrEmptyOrWhiteSpaces(instructor.supportPositionId)}
                      disabled={!this.canEditWorkingTime(instructor) || !isNullOrEmptyOrWhiteSpaces(instructor.supportPositionId)}
                      className="w-full border border-gray-300 rounded px-2 py-1"
                      value={instructor.workingHours ?? ''}
                      onChange={e => this.handleOnInstructorChange(index, 'workingHours', e.target.value)}
                    />
                  </div>
                )}

                {status.toString() !== 'Draft' && (
                  <>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">{t('Travel Days')}</label>
                      <DatesRangeInput
                        className="w-full  rounded px-2 py-1"
                        dontUseRedClearIconColor
                        readOnly={
                          !this.canEditWorkingDaysAndTravelDates(instructor) || !isNullOrEmptyOrWhiteSpaces(instructor.supportPositionId)
                        }
                        fromValue={instructor?.travelDays?.departure?.from}
                        toValue={instructor?.travelDays?.departure?.to}
                        onChange={(from, to) => this.handleTravelDays(index, 'departure', { from, to })}
                        placeholder={t('Departure')}
                        clearable
                        allowSameEndDate
                        getEveryChange
                      />
                      <DatesRangeInput
                        className="w-full  rounded px-2 py-1"
                        dontUseRedClearIconColor
                        readOnly={
                          !this.canEditWorkingDaysAndTravelDates(instructor) || !isNullOrEmptyOrWhiteSpaces(instructor.supportPositionId)
                        }
                        fromValue={instructor?.travelDays?.arrival?.from}
                        toValue={instructor?.travelDays?.arrival?.to}
                        onChange={(from, to) => this.handleTravelDays(index, 'arrival', { from, to })}
                        placeholder={t('Arrival')}
                        clearable
                        allowSameEndDate
                        getEveryChange
                      />
                    </div>
                    <div className="no-travel flex items-center gap-4">
                      <label className="block text-sm font-medium text-gray-700">{t('No Travel')}</label>
                      <div className="flex items-center">
                        <input
                          checked={instructor?.noTravel}
                          id="checked-checkbox"
                          type="checkbox"
                          value=""
                          className="w-4 h-4 text-black-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                          readOnly={
                            !this.canEditWorkingDaysAndNoTravel(instructor) || !isNullOrEmptyOrWhiteSpaces(instructor.supportPositionId)
                          }
                          onChange={data => this.handleNoTravel(index, data.target.checked)}
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
            ))}
        </div>
      </>
    );
  }
}

export default withTranslation()(EventInstructorContainer);
